/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Detail_Unreadable_RowInputs */



/**
* | output |
* | --- |
* | "This report could not be read, so its amount is not in the month total." |
*
* @param {Partner_Detail_Unreadable_RowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_unreadable_row = /** @type {((inputs?: Partner_Detail_Unreadable_RowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Unreadable_RowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Bericht konnte nicht gelesen werden, sein Betrag fehlt daher in der Monatssumme.")
	return /** @type {LocalizedString} */ ("This report could not be read, so its amount is not in the month total.")
});